var exports = {
  "kL": "x04b3a21e--efba95--container",
  "Qs": "x04b3a21e--efba95--content",
  "UU": "x04b3a21e--efba95--name",
  "YH": "x04b3a21e--efba95--full-name",
  "J9": "x04b3a21e--efba95--requisites",
  "yJ": "x04b3a21e--efba95--links",
  "_P": "x04b3a21e--efba95--site",
  "N0": "x04b3a21e--efba95--site-title",
  "V$": "x04b3a21e--efba95--socials",
  "gZ": "x04b3a21e--efba95--social-icon",
  "mp": "x04b3a21e--efba95--feedback",
};

module.exports = exports;
